<script setup lang="ts">
import type { Locale } from '@/composables/useI18n'

// Simplified flags drawn without clipPath/ids, so several can share a page
defineProps<{ code: Locale }>()
</script>

<template>
  <svg v-if="code === 'en'" class="flag-icon" viewBox="0 0 60 30" aria-hidden="true">
    <rect width="60" height="30" fill="#012169" />
    <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6" />
    <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" stroke-width="2" />
    <path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10" />
    <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6" />
  </svg>
  <svg v-else-if="code === 'es'" class="flag-icon" viewBox="0 0 750 500" aria-hidden="true">
    <rect width="750" height="500" fill="#c60b1e" />
    <rect width="750" height="250" y="125" fill="#ffc400" />
  </svg>
  <svg v-else-if="code === 'fr'" class="flag-icon" viewBox="0 0 3 2" aria-hidden="true">
    <rect width="1" height="2" fill="#002654" />
    <rect x="1" width="1" height="2" fill="#fff" />
    <rect x="2" width="1" height="2" fill="#ce1126" />
  </svg>
  <svg v-else-if="code === 'nl'" class="flag-icon" viewBox="0 0 9 6" aria-hidden="true">
    <rect width="9" height="2" fill="#ae1c28" />
    <rect y="2" width="9" height="2" fill="#fff" />
    <rect y="4" width="9" height="2" fill="#21468b" />
  </svg>
  <svg v-else class="flag-icon" viewBox="0 0 5 3" aria-hidden="true">
    <rect width="5" height="1" fill="#000" />
    <rect y="1" width="5" height="1" fill="#dd0000" />
    <rect y="2" width="5" height="1" fill="#ffce00" />
  </svg>
</template>

<style scoped>
.flag-icon {
  width: 18px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
  box-shadow: 0 0 0 1px var(--border);
}
</style>
